import { commitMutation,
  graphql } from 'react-relay';
import environment from '../.';
import { onErrorMutation } from './common/common';

const mutation = graphql`
mutation SignInMutation($email: String!, $password: String!) {
  signIn(email: $email, password: $password) { 
    ok
    error
    user {
      id
      userId
      username
      email
      roles
    }
    userTeam {
      id
      teamId
      name
      roles {
        role
        offerId
      }
      members {
        user {
          id
          email
        }
        roles {
          role
          offerId
        }
        active
      }
    }
  }
}
`;

export default (email, password, done) => {
  const variables = {
    email,
    password
  };

  commitMutation(
    environment(),
    {
      mutation,
      variables,
      onCompleted: ({ signIn }) => {
        const { ok, error, lockDuration } = signIn;
        done(ok, error, lockDuration);
      },
      onError: error => onErrorMutation(error, done)
    }
  );
};
